import { OrganisationSearchClient } from "../../../../../../Wrap/Api/Customer/OrganisationSearch";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { EntityType } from "../../../../../../Wrap/Constants/Enums/EntityType";

export interface IOrganisationSearchQuery {
    organisationStatus: CustomerStatus;
    organisationName: string;
    organisationType: CustomerType;
    clAccountId: string;
    entityId?: number;
    entityType?: EntityType;
}

export class OrganisationSearchAction {
    public static searchOrganisations(
        query: IOrganisationSearchQuery,
        currentPage,
        count,
        callBack?: (val: any) => void
    ): void {
        const client = new OrganisationSearchClient();
        const promise = client.get(
            null,
            query.organisationStatus,
            query.organisationType,
            null,
            null,
            query.organisationName,
            true,
            query.clAccountId,
            null,
            query.entityType,
            query.entityId,
            null,
            currentPage,
            count
        );
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {});
    }
}
